import {
  EmailLogin as EmailLoginTypes,
  FacebookLogin as FacebookLoginTypes,
  Signup as SignupTypes,
  Recover as RecoverTypes,
} from './types'
import loginComponentTypes from '../../sections/login/types/login'
import signupComponentTypes from '../../sections/signup/types/signup'
import {combineReducers} from 'redux'

function emailLogin(state = {
  email: '',
  password: '',
  isFetching: false,
  error: '',
}, action) {
  switch (action.type) {
    case EmailLoginTypes.SET_EMAIL:
      return Object.assign({}, state, {
        email: action.email,
      })
    case EmailLoginTypes.SET_PASSWORD:
      return Object.assign({}, state, {
        password: action.password,
      })
    case EmailLoginTypes.LOGIN_EMAIL:
      return Object.assign({}, state, {
        isFetching: true,
        error: '',
      })
    case EmailLoginTypes.RECEIVE_EMAIL_LOGIN:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    case loginComponentTypes.CLOSE:
      return Object.assign({}, state, {
        isFetching: false,
        error: '',
      })
    default:
      return state
  }
}

function facebookLogin(state = {
  isFetching: false,
  error: '',
}, action) {
  switch (action.type) {
    case FacebookLoginTypes.FACEBOOK_LOGIN:
      return Object.assign({}, state, {
        isFetching: true,
        error: '',
      })
    case FacebookLoginTypes.RECEIVE_FACEBOOK_LOGIN:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    case loginComponentTypes.CLOSE:
      return Object.assign({}, state, {
        isFetching: false,
        error: '',
      })
    case signupComponentTypes.CLOSE:
      return Object.assign({}, state, {
        isFetching: false,
        error: '',
      })
    default:
      return state
  }
}

function signup(state = {
  email: '',
  emailError: '',
  name: '',
  nameError: '',
  lastName: '',
  lastNameError: '',
  phone: '',
  phoneError: '',
  password: '',
  passwordError: '',
  isFetching: false,
  error: '',
}, action) {
  switch (action.type) {
    case SignupTypes.SIGN_UP_SET_EMAIL:
      return Object.assign({}, state, {
        email: action.email,
        emailError: action.emailError,
      })
    case SignupTypes.SIGN_UP_SET_NAME:
      return Object.assign({}, state, {
        name: action.name,
        nameError: action.nameError,
      })
    case SignupTypes.SIGN_UP_SET_LAST_NAME:
      return Object.assign({}, state, {
        lastName: action.lastName,
        lastNameError: action.lastNameError,
      })
    case SignupTypes.SIGN_UP_PHONE:
      return Object.assign({}, state, {
        phone: action.phone,
        phoneError: action.phoneError,
      })
    case SignupTypes.SIGN_UP_SET_PASSWORD:
      return Object.assign({}, state, {
        password: action.password,
        passwordError: action.passwordError,
      })
    case SignupTypes.SIGN_UP:
      return Object.assign({}, state, {
        isFetching: true,
        error: '',
      })
    case SignupTypes.RECEIVE_SIGN_UP:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
      })
    case signupComponentTypes.CLOSE:
      return Object.assign({}, state, {
        isFetching: false,
        error: '',
      })
    default:
      return state
  }
}

function recover(state = {
  step: 0,
  step1Email: '',
  step1EmailError: '',
  step1IsFetching: false,
  step1Error: '',
  step2Email: '',
  step2EmailError: '',
  step2Password: '',
  step2PasswordError: '',
  step2Code: '',
  step2CodeError: '',
  step2Error: '',
  step2IsFetching: false,
}, action) {
  switch (action.type) {
    case RecoverTypes.SET_STEP:
      return Object.assign({}, state, {
        step: action.step,
      })
    case RecoverTypes.STEP_1_SET_EMAIL:
      return Object.assign({}, state, {
        step1Email: action.step1Email,
        step1EmailError: action.step1EmailError,
      })
    case RecoverTypes.STEP_1_SEND_CODE:
      return Object.assign({}, state, {
        step1IsFetching: true,
        step1Error: '',
      })
    case RecoverTypes.STEP_1_RECEIVE_CODE:
      return Object.assign({}, state, {
        step1IsFetching: false,
        step1Error: action.step1Error,
      })
    case RecoverTypes.STEP_2_SET_EMAIL:
      return Object.assign({}, state, {
        step2Email: action.step2Email,
        step2EmailError: action.step2EmailError,
      })
    case RecoverTypes.STEP_2_SET_PASSWORD:
      return Object.assign({}, state, {
        step2Password: action.step2Password,
        step2PasswordError: action.step2PasswordError,
      })
    case RecoverTypes.STEP_2_SET_CODE:
      return Object.assign({}, state, {
        step2Code: action.step2Code,
        step2CodeError: action.step2CodeError,
      })
    case RecoverTypes.STEP_2_SEND_NEW_PASSWORD:
      return Object.assign({}, state, {
        step2IsFetching: true,
        step2Error: '',
      })
    case RecoverTypes.STEP_2_RECEIVE_NEW_PASSWORD:
      return Object.assign({}, state, {
        step2IsFetching: false,
        step2Error: action.step2Error,
      })
    default:
      return state
  }
}

export default combineReducers({emailLogin, facebookLogin, signup, recover})



// WEBPACK FOOTER //
// ./src/state/login/reducers.js